import { useContext, useState } from 'react';
import { Button, Textbox } from 'components/generic';
import { OnboardingContext } from 'providers/onboarding-provider';
import Images from 'assets/Images';
import { useFetch } from 'hooks';
import { useDispatch } from 'react-redux';
import { routeSlice } from 'redux/reducers';
import { cloneDeep } from 'lodash';
import { useNavigate } from 'react-router-dom';
import './style.scss';

const ClientLogin = () => {
	const context = useContext(OnboardingContext);
	const [loginObj, setLoginObj] = useState({});
	const [loginValidation, setLoginValidation] = useState(false);
	const [errorMsg, setErrorMsg] = useState(null);

	const navigate = useNavigate();
	const dispatch = useDispatch();
	const api = useFetch();

	// toggler switch between login and singup
	const handleSignup = () => {
		context.setSignupToggler('SIGNUP');
	};

	// handleLoginData Password & Email
	const handleLoginData = (e, key) => {
		setLoginObj(prevState => {
			const data = cloneDeep(prevState);
			data[key] = e;
			return data;
		});
	};

	// login api with onboarding
	const handleSAASOnboarding = async () => {
		try {
			const { data } = await api({ url: 'client/v1/login', method: 'post', data: loginObj, hideErrorToaster: true });
			const login = data?.data;
			const onboardingStatus = login?.op_status === 'COM';
			const route = onboardingStatus ? 'dashboard' : 'onboarding';
			localStorage.setItem('c_id', login?.c_id);
			setLoginStates(login);
			dispatch(routeSlice?.actions?.routeReducer(route));
			navigate(login?.access?.c_adminAccess === true ? 'invoice-slab-maintenance' : route);
			onboardingStatus && userDetails();
		} catch (error) {
			setErrorMsg(error);
		}
	};

	// login without onboarding
	const handleOnboarding = async () => {
		try {
			const { data } = await api({ url: 'client/v2/login', method: 'post', data: loginObj, hideErrorToaster: true });
			const login = data?.data;
			setLoginStates(login);
			localStorage.setItem('c_id', login?.c_id?.at());
			dispatch(routeSlice?.actions?.routeReducer('dashboard'));
			navigate('dashboard');
			userDetails();
		} catch (error) {
			setErrorMsg(error);
		}
	};

	const userDetails = async () => {
		const { data } = await api({ url: 'client/v1/userDetails', method: 'get' });
		data?.data && localStorage.setItem('_ud', JSON.stringify(data?.data));
	};

	const setLoginStates = params => {
		localStorage.setItem('_ac', params?.access?.access_token);
		localStorage.setItem('_sc', params?.access?.session_state);
		localStorage.setItem('_rc', params?.access?.refresh_token);
		localStorage.setItem('_am', params?.access?.c_adminAccess);
		localStorage.setItem('_cl', params?.access?.c_clientAdmin);
	};

	// handlevalidation for login
	const handleValidation = () => {
		setLoginValidation(!loginObj?.c_password || !loginObj?.c_username);
		loginObj?.c_password && loginObj?.c_username && (process.env.REACT_APP_STANDALONE_APP === 'Y' ? handleSAASOnboarding() : handleOnboarding());
	};

	// toaster to show error messages
	const toaster = errorMsg && (
		<div className='client-login__error'>
			<img src={Images.error_alert} />
			{errorMsg}
		</div>
	);

	return (
		<div className='client-login scroll-bar'>
			<h1>Login</h1>
			{toaster}
			<Textbox
				label='Username'
				mandatory
				infoContent='Enter the username'
				placeholder='Enter username'
				value={loginObj?.c_username}
				id='username_login'
				onChange={e => handleLoginData(e?.target?.value, 'c_username')}
				error={!loginObj?.c_username && loginValidation}
				errorMessage={!loginObj?.c_username && loginValidation ? 'This field is required.' : ''}
			/>
			<Textbox
				type='Password'
				label='Password'
				infoContent='Enter the password'
				mandatory
				id='password_login'
				placeholder='Enter Password'
				onChange={e => handleLoginData(e?.target?.value, 'c_password')}
				value={loginObj?.c_password}
				error={!loginObj?.c_password && loginValidation}
				errorMessage={!loginObj?.c_password && loginValidation ? 'This field is required.' : ''}
			/>
			{process.env.REACT_APP_STANDALONE_APP === 'Y' && (
				<span className='flex-end hyperlink' onClick={() => context.setSignupToggler('RESET_PWD')}>
					Forgot password?
				</span>
			)}
			<Button label='Login' primary full handleOnSubmit={handleValidation} />
			{process.env.REACT_APP_STANDALONE_APP === 'Y' && (
				<div className='client-login__account'>
					Don't have an account?
					<span className='hyperlink client-login__tag' onClick={handleSignup}>
						Sign up
					</span>
				</div>
			)}
		</div>
	);
};

export default ClientLogin;
